module.exports = __webpack_public_path__ + "img/healthProMobile4-EN.653b3100.png";